
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, labelModule } from '@/store/modules/store-accessor'

@Component
export default class DeleteExpenseLabelModal extends Vue {
  @Prop()
  payload!: Record<string, any>;

  isDeletingExpenseLabel = false;

  async hideModal () {
      commonModule.hideModal();
  }

  async mounted() {
    commonModule.initSnackbar({});
  }

  async doDeleteExpenseLabel () {
    this.isDeletingExpenseLabel = true;

    await labelModule.deleteExpenseLabel(this.payload.label);

    this.isDeletingExpenseLabel = false;
    this.hideModal();
  }
};
